/**
 * Shared "related user" id resolution for Home, Patient, and reporting APIs.
 *
 * Priority:
 * 1. `RelatedUserId` query param (explicit / embed)
 * 2. Logged-in Wix user id (when isWixAuth)
 * 3. Radical permissions user id
 * 4. Optional study payload user id (Patient after study loads)
 */

/**
 * @param {string} [search] - `location.search` (with or without leading `?`)
 * @returns {string|null}
 */
export function getRelatedUserIdFromSearch(search) {
  if (search == null || search === "") return null;
  const normalized = search.startsWith("?") ? search : `?${search}`;
  const params = new URLSearchParams(normalized);
  const v = params.get("RelatedUserId");
  return v?.trim() ? v.trim() : null;
}

/**
 * @param {object} [opts]
 * @param {string} [opts.search] - `location.search`
 * @param {boolean} [opts.isWixAuth]
 * @param {string} [opts.wixUserId]
 * @param {string} [opts.creUserId]
 * @param {string} [opts.radicalUserId]
 * @param {string} [opts.studyUserId] - e.g. from GetUserStudy / getStudyById payload
 * @returns {string|null}
 */
export function resolveRelatedUserId({
  search,
  isWixAuth,
  wixUserId,
  creUserId,
  radicalUserId,
  studyUserId,
} = {}) {
  const fromUrl =
    typeof search === "string" ? getRelatedUserIdFromSearch(search) : null;
  if (fromUrl) return fromUrl;
  if (isWixAuth && wixUserId) return wixUserId;
  if (creUserId) return creUserId;
  if (radicalUserId) return radicalUserId;
  if (studyUserId) return studyUserId;
  return null;
}
